import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { usePermissions } from "hooks/permission";

import { useAppSelector } from "store/rootReducer";

import { httpType } from "global/types";

import { ContainerCrud, permitionsCrud } from "features/cruds";
import { IFormOneLabel } from "features/forms/FormOneLabel/interface";
import { IModelFormBase } from "features/forms/optionsForms";
import { AdminAreaSkeleton } from "features/LoadSkeleton";

import api from "services/api";

import { FORMS_ADMIN } from "utils/entities/permission";


export const HearingType: React.FC = () => {
  const { t } = useTranslation();
  const [onSubmitForm, setOnSubmitForm] = useState<number>(0);
  const [objectRetorned, setObjectRetorned] = useState<IFormOneLabel | null>(
    null,
  );
  const [httpType, setHttpType] = useState<httpType>("post");
  const [listAttendant, setListAttendant] = useState<Array<IFormOneLabel>>([]);

  const [loading, setLoading] = useState<boolean>(true);

  const { user } = useAppSelector((state) => state.user);

  const { read, create, edit } = usePermissions(FORMS_ADMIN.HEARING_TYPE);

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    setLoading(true);
    const attendantRoles = await api.get(
      `/v1/HearingType/GetAllByCustomerId?customerId=${user?.customerId}`,
    );

    setListAttendant(attendantRoles.data.data ?? []);
    setLoading(false);
  }

  const modelFormBase: IModelFormBase = {
    api: api,
    endPoint: "/v1/HearingType/",
    httpType: httpType,
    setHttpType: setHttpType,
    list: listAttendant,
    onSubmitForm: onSubmitForm,
    setOnSubmitForm: setOnSubmitForm,
    objectRetorned: objectRetorned,
    setObjectRetorned: setObjectRetorned,
  };

  const formOneLabel: IFormOneLabel = {
    active: true,
    customerId: user?.customerId,
    displayLabel: t("audiences.type"),
    id: 0,
    name: "",
    modelFormBase: modelFormBase,
    titleToast: t("audiences.type"),
  };

  const permissions: permitionsCrud = {
    inactivate: false,
    toCreate: create,
    toEdit: edit,
    toRead: read,
  };

  return (
    <ContainerCrud
      list={listAttendant}
      title={t("audiences.type")}
      emptyListMessage={t("audiences.typeNotFound")}
      permissions={permissions}
      customProsForm={formOneLabel}
      modelFormBase={modelFormBase}
      optionForm="FormOneLabel"
      loading={loading}
      isAudience={t("audiences.type")}
      SkeletonComponent={AdminAreaSkeleton}
    />
  );
};
